exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".red{color:red}.blue{color:#339}.green{color:#396}.yellow{color:#f90}.orange{color:#c65911}.black{color:#000}.rule-detail{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/views/evaluation/score-tips/tips-colors.css
// module id = 858
// module chunks = 23